const MalaysiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111821)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.1309 20.0006H40.0004C40.0004 18.1954 39.7598 16.4468 39.3114 14.7832H19.1309V20.0006Z"
        fill="#D80027"
      />
      <path
        d="M19.1309 9.56605H37.0649C35.8406 7.56824 34.2754 5.80238 32.4502 4.34863H19.1309V9.56605Z"
        fill="#D80027"
      />
      <path
        d="M20.0005 39.9992C24.7075 39.9992 29.0338 38.3723 32.4503 35.6514H7.55078C10.9673 38.3723 15.2936 39.9992 20.0005 39.9992Z"
        fill="#D80027"
      />
      <path
        d="M2.93545 30.4342H37.0645C38.0474 28.8305 38.8096 27.0773 39.311 25.2168H0.688965C1.19029 27.0773 1.95256 28.8305 2.93545 30.4342Z"
        fill="#D80027"
      />
      <path d="M20 20C20 8.95437 20 7.65219 20 0C8.95437 0 0 8.95437 0 20H20Z" fill="#0052B4" />
      <path
        d="M13.2997 17.1194C10.5683 17.1194 8.35406 14.9051 8.35406 12.1738C8.35406 9.44246 10.5684 7.22816 13.2997 7.22816C14.1513 7.22816 14.9527 7.44355 15.6523 7.82262C14.5548 6.74941 13.0538 6.08691 11.3975 6.08691C8.03586 6.08691 5.31055 8.81215 5.31055 12.1739C5.31055 15.5356 8.03586 18.2608 11.3975 18.2608C13.0538 18.2608 14.5548 17.5983 15.6523 16.5251C14.9527 16.904 14.1514 17.1194 13.2997 17.1194Z"
        fill="#FFDA44"
      />
      <path
        d="M14.6933 8.69531L15.5713 10.5314L17.5542 10.0733L16.6663 11.9045L18.261 13.1691L16.2755 13.6166L16.281 15.6519L14.6933 14.3786L13.1055 15.6519L13.111 13.6166L11.1255 13.1691L12.7202 11.9045L11.8321 10.0733L13.8152 10.5314L14.6933 8.69531Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111821">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MalaysiaSvg;
